import type { ReactNode } from "react";
import { useFavoriteSync } from "@/hooks/useFavoriteSync";

// 全 Inertia ページの共通レイアウトとして差し込み、ログイン直後の
// LocalStorage → DB お気に入り同期を一度だけ起動する。DOM は包まずそのまま子を返す。
export default function FavoriteSyncProvider({ children }: { children: ReactNode }) {
  useFavoriteSync();
  return <>{children}</>;
}
